import * as React from 'react';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { DatePicker as WSRDatePicker } from 'wix-style-react-tpa';
import { TextField, TextFieldTheme } from '../TextField';
import { IconButton } from '../IconButton';
import { Calendar } from '@wix/wix-ui-icons-common/on-stage';
import { st, classes } from './DatePickerInput.st.css';
import { DATA_HOOKS } from './constants';
import { ErrorMessageWrapper } from '../internal/ErrorMessageWrapper';
import uniqueId from '../../common/uniqueId';
/** The Date pickers presents a calendar and allows a user to select a specific date. */
export class DatePickerInput extends React.Component {
    constructor(props) {
        super(props);
        this.WSRDatePickerRef = React.createRef();
        this._handleCalendarOpen = () => {
            this.setState({ isOpen: true });
        };
        this._handleCalendarClose = () => {
            this.setState({ isOpen: false });
        };
        this._onInputClearButtonClicked = () => {
            const { onChange } = this.props;
            onChange(null);
            if (this.WSRDatePickerRef.current &&
                this.WSRDatePickerRef.current.closeCalendar) {
                this.WSRDatePickerRef.current.closeCalendar();
            }
        };
        this.state = { isOpen: false };
        this._errorMessageId = uniqueId('error-message');
    }
    render() {
        const { className, value, onChange, onClose, onOpen, placeholderText, disabled, locale, excludePastDates, filterDate, firstDayOfWeek, hasError, errorAppearance, errorMessage, showMonthDropdown, showYearDropdown, inputWidth, inputTheme, popoverPlacement, popoverAppendTo, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, dateInputAriaLabel, dateInputAriaLabelledby, clearButtonAriaLabel, clearButtonAriaLabelledby, leftArrowAriaLabel, leftArrowAriaLabelledBy, rightArrowAriaLabel, rightArrowAriaLabelledBy, monthDropdownAriaLabel, monthDropdownAriaLabelledBy, yearDropdownAriaLabel, yearDropdownAriaLabelledBy, suffixButtonAriaLabel, suffixButtonAriaLabelledby, newErrorMessage, label, removeClearButton, zIndex, } = this.props;
        const CustomInput = (wsrProps) => {
            const { value: formattedValue, onFocus, onBlur, onInputClicked, onKeyDown, tabIndex, } = wsrProps;
            return (React.createElement(TextField, { role: "combobox", "aria-haspopup": "dialog", "aria-expanded": this.state.isOpen, label: label, className: classes.textField, "data-hook": DATA_HOOKS.DATE_INPUT, value: formattedValue, placeholder: placeholderText, suffix: React.createElement(IconButton, { "aria-label": suffixButtonAriaLabel, "aria-labelledby": suffixButtonAriaLabelledby, icon: React.createElement(Calendar, null), onClick: disabled ? undefined : onInputClicked }), tabIndex: tabIndex, disabled: disabled, error: hasError, errorMessage: !newErrorMessage && errorMessage, newErrorMessage: newErrorMessage, theme: inputTheme, withClearButton: !removeClearButton, onFocus: onFocus, onBlur: onBlur, onClick: onInputClicked, onKeyDown: onKeyDown, onClear: this._onInputClearButtonClicked, clearButtonAriaLabel: clearButtonAriaLabel, clearButtonAriaLabelledby: clearButtonAriaLabelledby, "aria-label": dateInputAriaLabel, "aria-labelledby": dateInputAriaLabelledby, inputMode: "none", readOnly: true }));
        };
        const Wrapper = newErrorMessage ? ErrorMessageWrapper : React.Fragment;
        const stStates = {
            newError: hasError && newErrorMessage,
        };
        return (React.createElement(TPAComponentsConsumer, null, ({ rtl }) => (React.createElement(Wrapper, { ...(newErrorMessage && {
                visible: hasError && !!errorMessage,
                message: errorMessage,
                errorAppearance,
                messageId: this._errorMessageId,
                className: st(classes.root, stStates, classes.overrideStyleParams, className),
                'data-hook': this.props['data-hook'],
            }) },
            React.createElement("div", { ...(!newErrorMessage && {
                    className: st(classes.root, stStates, classes.overrideStyleParams, className),
                    'data-hook': this.props['data-hook'],
                }), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy },
                React.createElement(WSRDatePicker, { ref: this.WSRDatePickerRef, dataHook: DATA_HOOKS.WSR_DATE_PICKER, className: classes.wsrDatePicker, value: value, onChange: (selectedDays) => onChange(selectedDays), onClose: (e) => {
                        this._handleCalendarClose();
                        onClose?.(e);
                    }, onOpen: (e) => {
                        this._handleCalendarOpen();
                        onOpen?.(e);
                    }, disabled: disabled, locale: locale, excludePastDates: excludePastDates, filterDate: filterDate, firstDayOfWeek: firstDayOfWeek, showMonthDropdown: showMonthDropdown, showYearDropdown: showYearDropdown, customInput: React.createElement(CustomInput, null), width: inputWidth, rtl: rtl, selectionMode: "day", shouldCloseOnSelect: true, initialOpen: false, numOfMonths: 1, popoverProps: {
                        placement: popoverPlacement
                            ? popoverPlacement
                            : rtl
                                ? 'bottom-end'
                                : 'bottom-start',
                        appendTo: popoverAppendTo,
                        dynamicWidth: popoverAppendTo === 'window' ? true : undefined,
                    }, leftArrowAriaLabel: leftArrowAriaLabel, leftArrowAriaLabelledBy: leftArrowAriaLabelledBy, rightArrowAriaLabel: rightArrowAriaLabel, rightArrowAriaLabelledBy: rightArrowAriaLabelledBy, monthDropdownAriaLabel: monthDropdownAriaLabel, monthDropdownAriaLabelledBy: monthDropdownAriaLabelledBy, yearDropdownAriaLabel: yearDropdownAriaLabel, yearDropdownAriaLabelledBy: yearDropdownAriaLabelledBy, zIndex: zIndex }))))));
    }
}
DatePickerInput.displayName = 'DatePickerInput';
DatePickerInput.defaultProps = {
    placeholderText: 'MM/DD/YY',
    disabled: false,
    locale: 'en',
    excludePastDates: false,
    filterDate: () => true,
    showMonthDropdown: false,
    showYearDropdown: false,
    hasError: false,
    inputWidth: '280px',
    inputTheme: TextFieldTheme.Box,
    removeClearButton: false,
};
//# sourceMappingURL=DatePickerInput.js.map